import React, { useMemo } from 'react';

export interface CandidatePromptProps {
    prompts?: string[];
    onPromptClick?: (text: string) => void;
}

const DEFAULT_PROMPTS = [
    "🐰Who are the Labubu family ",
    "🔍 What happens after AGI ",
    "💻 Explain quantum computing ",
    "📃 Help me read this financial report",
    "🌍 Why is the sky dark at night",
    "🧠 Why do we dream",
    "⏳ Why does time feel faster as we age",
    "⚛️ How does quantum computing really work",
    "🌌 What is dark matter",
    "🔁 Why history repeats itself",
    "📡 How the internet actually works",
    "💡 What is consciousness",
    "🧬 How DNA stores information",
    "🧠 Why we forget things",
    "🧠 How does AI actually learn",
    "💻 Explain quantum computing",
    "🕶️ What is the metaverse now",
    "📱 How do recommendation algorithms work",
    "🧠 Why AI hallucinates",
    "🛠️ How does ChatGPT work",
    "📊 Why data is the new oil",
    "🔐 How encryption protects data",
    "🛰️ How satellites talk to Earth",
    "📃 Help me read this financial report",
    "📉 Why did this stock drop",
    "💵 How inflation affects me",
    "🏦 How central banks control money",
    "📈 Explain this earnings call",
    "🧾 What does this contract really mean",
    "🏠 Rent vs buy in 2025",
    "💳 How credit scores work",
    "💼 Why startups fail",
    "📊 Explain this chart",
    "😵 Why do I procrastinate",
    "❤️ Why we fall in love",
    "😴 Why I’m always tired",
    "🧠 Why we overthink",
    "🎶 Why music makes us emotional",
    "😬 Why we care what others think",
    "😡 Why anger spreads",
    "😊 Why happiness fades",
    "🧩 Why habits are hard to change",
    "🍎 Why Apple designs products this way",
    "🧠 How OpenAI actually makes money",
    "🛒 Why Amazon is still not “profitable”",
    "🚗 How Tesla really changed the car industry",
    "🟦 Why Facebook became Meta",
    "🎬 How Netflix decides what to make",
    "📱 Why iPhone users rarely switch",
    "🛍️ How Shein became so fast",
    "🏦 Why banks fear fintech startups",
    "🧃 How Coca-Cola built a global brand",
    "🐭 How Disney builds IP empires",
    "🦸 Why Marvel movies feel different now",
    "⚡ How Harry Potter became a global phenomenon",
    "🧙 Why Studio Ghibli feels so calming",
    "🧩 How Pokémon lasted 30 years",
    "🐉 Why Game of Thrones failed at the end",
    "🎮 How Nintendo designs fun",
    "🌌 Why Star Wars still matters",
    "👑 How One Piece built such loyal fans",
    "🧸 Why Labubu is suddenly everywhere",
    "🎤 How Taylor Swift built her empire",
    "🎬 Why Christopher Nolan avoids CGI",
    "🎮 How MrBeast understands the internet",
    "🎧 How Spotify changed music",
    "🏀 Why Michael Jordan became a brand",
    "🎭 Why actors burn out in Hollywood",
    "📺 How YouTubers really make money",
    "🎤 Why K-pop idols are trained this way",
    "🎬 How Pixar tells stories",
    "🎥 Why some directors always succeed",
    "🤖 What OpenAI vs Google is really about",
    "🍏 Why Apple vs Samsung never ends",
    "📱 How TikTok rewired attention",
    "🧠 Why AI startups burn cash",
    "💾 How Nvidia became so powerful",
    "🧪 Why biotech startups fail so often",
    "🌍 Why Big Tech fears regulation",
    "📊 How algorithms shape culture",
    "🔐 Why privacy is disappearing",
    "🛰️ How SpaceX lowered launch costs",
    "🧨 Why Elon Musk is so controversial",
    "🔥 Why cancel culture exists",
    "🎭 Why celebrities lose fans overnight",
    "🧠 Why social media makes us anxious",
    "📉 Why startups collapse after hype",
    "🎬 Why remakes keep failing",
    "🛍️ Why luxury brands raise prices",
    "🧸 Why adult collectibles are booming",
    "🎮 Why games become addictive",
    "📺 Why streaming feels worse now",
];

function shuffle<T>(arr: T[]): T[] {
    const a = [...arr];
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}

export const CandidatePrompt: React.FC<CandidatePromptProps> = ({
    prompts = DEFAULT_PROMPTS,
    onPromptClick,
}) => {
    const displayPrompts = useMemo(
        () => shuffle(prompts).slice(0, 5),
        [prompts],
    );

    return (
        <div className="w-full text-center">
            <div className="text-center text-sm text-black mb-3 font-bold">
                Try these topics:
            </div>
            <div className="flex flex-wrap gap-3 justify-center overflow-hidden max-h-12">
                {displayPrompts.map((text, index) => (
                    <button
                        type="button"
                        key={`${index}-${text}`}
                        className="shrink-0 w-fit px-4 py-3 rounded-full border border-black/10 bg-white text-sm cursor-pointer hover:bg-black/5 transition-colors text-left"
                        onClick={() => onPromptClick?.(text)}
                    >
                        {text}
                    </button>
                ))}
            </div>
        </div>
    );
};
